class HoverBurst extends HTMLElement {
  static iconNode = null;
  static prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  connectedCallback() {
    if (HoverBurst.prefersReducedMotion) return;

    if (!HoverBurst.iconNode) {
      const tpl = document.querySelector('.hover-burst-icon-template');
      if (!tpl) return;
      HoverBurst.iconNode = tpl.content.firstElementChild;
    }

    this.addEventListener('mouseenter', this.#spawn);
  }

  #spawn = (event) => {
    if (!HoverBurst.iconNode) return;

    const rect = this.getBoundingClientRect();
    const originX = event.clientX - rect.left;
    const originY = event.clientY - rect.top;

    this.classList.remove('is-shaking');
    void this.offsetWidth;
    this.classList.add('is-shaking');

    const count = 3 + Math.floor(Math.random() * 3);

    for (let i = 0; i < count; i++) {
      const heart = HoverBurst.iconNode.cloneNode(true);
      heart.classList.add('hover-burst-particle');

      const angle = Math.random() * 2 * Math.PI;
      const distance = 40 + Math.random() * 40;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance - 20;
      const rotation = (Math.random() - 0.5) * 60;
      const delay = Math.random() * 80;

      heart.style.setProperty('--origin-x', `${originX}px`);
      heart.style.setProperty('--origin-y', `${originY}px`);
      heart.style.setProperty('--dx', `${dx}px`);
      heart.style.setProperty('--dy', `${dy}px`);
      heart.style.setProperty('--rotation', `${rotation}deg`);
      heart.style.animationDelay = `${delay}ms`;

      heart.addEventListener('animationend', () => heart.remove(), { once: true });
      this.appendChild(heart);
    }
  };
}

if (!customElements.get('hover-burst')) {
  customElements.define('hover-burst', HoverBurst);
}
